// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"381":"f6a4bdfa","404":"3da3e838","524":"b41eda2f"}[chunkId] + ".css";
};